import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
//browser router will make the props availabe to other components
import App from "./home/App";
 import Calculator from "./calculator/Calculator";
 import Todo from "./todo/Todo";
// import Blog from "./Blog";
import Grade from "./grade/Grade";
import News from "./news/News";
import UrgentCare from "./urgentcare/UrgentCare";
import Covid from "./covid/Covid";
import Stacks from "./stacks/Stacks";
import Store from "./store/Store";
import BinaryCalculator from "./binarycalculator/BinaryCalculator";




const Routes = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact component={App} />
                <Route path="/todo" exact component={Todo} />
                <Route path="/covid" exact component={Covid} />
                <Route path="/news" exact component={News} />
                <Route path="/grade" exact component={Grade} />
                <Route path="/calculator" exact component={Calculator} />
                <Route path="/urgentcare" exact component={UrgentCare} />
                <Route path="/stacks" exact component={Stacks} />
                <Route path="/store" exact component={Store} />
                <Route path="/binary-calculator" exact component={BinaryCalculator} />

                <Redirect from="/News" to="/news" />
                <Redirect from="/Grade" to="/grade" />
                <Redirect from="/Calculator" to="/calculator" />

                {/* <Route path="/Blog" exact component={Blog} />  */}
            </Switch> 
        </BrowserRouter>
    );
};

export default Routes;
